import { render, staticRenderFns } from "./api-token.vue?vue&type=template&id=33b61ca9&scoped=true&"
import script from "./api-token.vue?vue&type=script&lang=js&"
export * from "./api-token.vue?vue&type=script&lang=js&"
import style0 from "./api-token.vue?vue&type=style&index=0&id=33b61ca9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b61ca9",
  null
  
)

export default component.exports